/* Diesel Hemp — collapse long product description tabs with a "Read more" toggle.
   Scoped to product pages via the .product-tabs container. */
document.addEventListener('DOMContentLoaded', function () {
  var COLLAPSE_AT = 150;

  document.querySelectorAll('.product-tabs').forEach(function (tabs) {
    var content = tabs.querySelector('.product-tabs__content');
    if (!content || content.querySelector('.eq-readmore-btn')) return;

    var userInteracted = false;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'eq-readmore-btn';
    btn.textContent = 'Read more';
    content.appendChild(btn);

    function activePanel() {
      return content.querySelector('.product-tab-panel.active');
    }

    function apply() {
      content.querySelectorAll('.product-tab-panel').forEach(function (p) {
        p.classList.remove('eq-collapsible', 'eq-expanded');
      });
      var panel = activePanel();
      if (!panel) {
        btn.style.display = 'none';
        return;
      }
      if (panel.scrollHeight > COLLAPSE_AT + 60) {
        panel.classList.add('eq-collapsible');
        btn.style.display = 'inline-block';
        btn.textContent = 'Read more';
      } else {
        btn.style.display = 'none';
      }
    }

    btn.addEventListener('click', function () {
      var panel = activePanel();
      if (!panel) return;
      userInteracted = true;
      if (panel.classList.contains('eq-expanded')) {
        panel.classList.remove('eq-expanded');
        btn.textContent = 'Read more';
        tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        panel.classList.add('eq-expanded');
        btn.textContent = 'Read less';
      }
    });

    tabs.querySelectorAll('.product-tab-btn').forEach(function (tabBtn) {
      tabBtn.addEventListener('click', function () {
        userInteracted = false;
        setTimeout(apply, 0);
      });
    });

    apply();
    window.addEventListener('load', function () {
      if (!userInteracted) apply();
    });
  });
});
